const driverShifts = {
  filters: {
    suppliers: 'Flotas',
  },

  form: {
    information: {
      shiftDetails: {
        fields: {
          suppliers: 'Flotas',
        },
      },
    },
  },
  calendarTable: {
    filters: {
      suppliers: 'Flotas',
    },
  },
};

export default driverShifts;
